const { trapFocus, disableTrapFocus } = window.BAO.Utils

class ShoeFinderDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    window.BAO = window.BAO || {}
    window.BAO.shoeFinder = window.BAO.shoeFinder || {
      active: false,
    }

    this.defaultDocumentTitle = document.title
    this.drawerActive = false
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )
  }

  handleClick (event) {
    const EVENTS = {
      TRIGGER: 'TRIGGER',
      CLOSE: 'CLOSE',
      QUICK_BUY_TRIGGER: 'QUICK_BUY_TRIGGER',
      OVERLAY_BACKDROP: 'OVERLAY_BACKDROP',
      DRAWER_CLOSE: 'DRAWER_CLOSE',
      UNKNOWN: 'UNKNOWN',
    }

    const eventType = (() => {
      if (event.target.closest(this.externalEls?.trigger?.selector) !== null) {
        return EVENTS.TRIGGER
      } else if (
        event.target.closest(this.externalEls?.close?.selector) !== null
      ) {
        return EVENTS.CLOSE
      } else if (
        event.target.closest(this.externalEls?.overlayBackdrop?.selector) !==
        null
      ) {
        return EVENTS.OVERLAY_BACKDROP
      } else if (
        event.target.closest('[data-quick-buy-external-el="trigger"]') !== null
      ) {
        return EVENTS.QUICK_BUY_TRIGGER
      } else if (event.target.closest('[data-drawers-close]') !== null) {
        return EVENTS.DRAWER_CLOSE
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN) {
      return
    }

    event.preventDefault()

    if (eventType === EVENTS.TRIGGER) {
      const triggerEl = event.target.closest(
        this.externalEls?.trigger?.selector,
      )

      if (!triggerEl) return

      if (triggerEl.dataset.triggerType === 'restart') {
        this.shoeFinderEl?.handleRestartClick(event, false)
      }

      if (triggerEl.dataset.triggerType === 'edit') {
        const carouselEl = document.querySelector('shoe-finder-carousel')
        if (carouselEl) {
          carouselEl.moveToIdx(0)
        }
      }

      this.openDrawer()
    }

    if (eventType === EVENTS.CLOSE) {
      this.closeDrawer()
    }

    if (eventType === EVENTS.QUICK_BUY_TRIGGER) {
      if (this.drawerActive && this.externalEls.overlayBackdrop?.exists) {
        this.externalEls.overlayBackdrop.element.classList.add(
          this.overlayBackdropActiveClass,
        )
      }
    }

    if (eventType === EVENTS.OVERLAY_BACKDROP) {
      event.preventDefault()
      window.drawers.activeDrawerKey = ''

      if (this.externalEls.overlayBackdrop?.exists) {
        this.externalEls.overlayBackdrop.element.classList.remove(
          this.overlayBackdropActiveClass,
        )
      }
    }

    if (eventType === EVENTS.DRAWER_CLOSE) {
      if (this.externalEls.overlayBackdrop?.exists) {
        this.externalEls.overlayBackdrop.element.classList.remove(
          this.overlayBackdropActiveClass,
        )
      }
    }
  }

  openDrawer () {
    if (this.drawerActive === true) return

    this.classList.add(this.activeClass)

    document.title = this.shoeFinderDocumentTitle

    trapFocus(this)

    this.drawerActive = true

    document.body.classList.add('util-SiteOverflowed')
  }

  closeDrawer () {
    if (this.drawerActive === false) return

    this.classList.remove(this.activeClass)

    document.title = this.defaultDocumentTitle

    disableTrapFocus(this)

    this.drawerActive = false

    window.drawers.activeDrawerKey = ''
  }

  get drawerActive () {
    return window.BAO.shoeFinder.active === true
  }

  set drawerActive (value) {
    window.BAO.shoeFinder.active = value === true

    document.body.classList.toggle(
      'lyt-Theme-shoeFinderActive',
      value === true,
    )
  }

  get shoeFinderEl () {
    return document.querySelector(this.shoeFinderSelector)
  }

  get shoeFinderSelector () {
    return `shoe-finder`
  }

  get activeClass () {
    return `sf-Drawer-active`
  }

  get activeBodyClass () {
    return `lyt-Theme-shoeFinderActive`
  }

  get overlayBackdropActiveClass () {
    return 'sf-OverlayBackdrop-active'
  }

  get shoeFinderDocumentTitle () {
    return this.dataset.documentTitle || 'P448 Shoe Finder'
  }
}

if (!customElements.get('shoe-finder-drawer')) {
  customElements.define('shoe-finder-drawer', ShoeFinderDrawer)
}
